import React from 'react';


const ImageWithText = (props) => {
    function createMarkup(item) {
        return {__html: item};
      }
    return (
        <section className={`about-sec ${props.class}`}>
            <div className="container c_container">
                <div className="row">
                    <div className="col-lg-6 order-1 order-lg-0">
                        <div className="about-left">
                            <h6 className="small-heading" data-aos="fade-up">{props.smallHeading}</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">{props.heading}</h3>
                            <p className="para-16" data-aos="fade-up" dangerouslySetInnerHTML={createMarkup(props.para)} />
                            {props.buttonLabel && <a href={props.buttonLink} className="btn custom-btn2" data-aos="fade-up">{props.buttonLabel}</a>}
                        </div>
                    </div>
                    <div className="col-lg-6 order-0 order-lg-0">
                        <div className="about-right" data-aos="fade-up">
                            <img src={props.image} alt="" className="w-100" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageWithText;